import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

import colors from "constants/palette";
ChartJS.register(ArcElement, Tooltip, Legend);

export const datass = {
  labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
  datasets: [
    {
      label: "# of Votes",
      data: [12, 19, 3, 5, 2, 3],
      backgroundColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

export default function App({ data }) {
  console.log(data);
  const xxx = {
    labels: data.map((item) => item.title),
    datasets: [
      {
        label: "نمودار درصد کالاها از کل",
        data: data.map((item) => (item.stock ? item.stock : 0)),
        backgroundColor: data.map(
          () =>
            `rgba(100, ${Math.random() * (250 - 20) + 20}, ${
              Math.random() * (250 - 160) + 160
            }, 1)`
        ),
        borderColor: colors.white,
      },
    ],
  };
  return <Pie data={xxx} />;
}
